export const geneticsMethodsModule = {
  id: "methods",
  title: "Genetics Methods",
  sections: [
    {
      type: "text",
      content:
        "PCR amplifies DNA; FISH detects chromosomal abnormalities; karyotype shows large deletions/duplications.",
    },
    {
      type: "text",
      content:
        "Chromosome and DNA Analysis",
    },
    {
      type: "text",
      content:
        "Methylation Analysis",
    },
    {
      type: "text",
      content:
        "RNA Analysis",
    },
    {
      type: "text",
      content:
        "Protein Analysis",
    },
    {
      type: "question",
      text: "Which test is best for detecting microdeletions?",
      options: ["Karyotype", "FISH", "Western blot", "ELISA"],
      correct: 1,
      explanation: "FISH is used to detect microdeletions and duplications.",
    },
  ],
};
